(function () {
  function normalize(value) {
    return (value || "").trim().toLowerCase();
  }

  function triggerText(node) {
    var text = Array.prototype.slice.call(node.childNodes).reduce(function (value, child) {
      return child.nodeType === Node.TEXT_NODE ? value + " " + child.textContent : value;
    }, "");

    return normalize(text || node.textContent);
  }

  function matchesUrl(node, url) {
    var nodeUrl = node.href || node.dataset.link || node.getAttribute("data-link");
    if (!url || !nodeUrl) return false;
    return new URL(nodeUrl, window.location.origin).href === new URL(url, window.location.origin).href;
  }

  function findTriggers(menu) {
    var label = normalize(menu.dataset.triggerLabel);
    var url = menu.dataset.triggerUrl || "";
    var selectors = [
      ".site-nav a[href]",
      ".site-nav__link[href]",
      ".site-nav__link[data-link]",
      ".site-nav summary.site-nav__link",
      ".mobile-nav a[href]",
      ".mobile-nav button",
      ".mobile-nav [data-link]",
      ".mobile-nav__link[href]",
      ".mobile-nav__link--button",
      ".drawer__contents a[href]",
      ".drawer__contents button",
      ".drawer__contents [data-link]",
      "header a[href]",
      "header button",
      "header summary",
      ".shopify-section-header a[href]",
      ".shopify-section-header button",
      ".shopify-section-header summary",
      "nav a[href]",
      "nav button",
      "nav summary",
      "a[href]"
    ];
    var links = Array.prototype.slice.call(document.querySelectorAll(selectors.join(",")));

    return links.filter(function (link) {
      var text = triggerText(link);
      var textMatches = label && (text === label || text.indexOf(label) === 0);
      var urlMatches = matchesUrl(link, url);
      return textMatches || urlMatches;
    });
  }

  function closeOtherMenus(current) {
    document.querySelectorAll(".smm.is-open").forEach(function (menu) {
      if (menu !== current) menu.classList.remove("is-open");
    });
  }

  function setupMenu(menu) {
    if (menu.dataset.smmReady === "true") return;

    var triggers = findTriggers(menu);
    var panel = menu.querySelector(".smm__panel");
    var closeTimer;
    var originalParent = menu.parentNode;
    var originalNextSibling = menu.nextSibling;

    if (!triggers.length || !panel) return;

    menu.dataset.smmReady = "true";
    panel.id = panel.id || menu.id + "-panel";

    function isMobile() {
      return window.matchMedia("(max-width: 989px)").matches;
    }

    function restoreMenuPosition() {
      if (!originalParent || menu.parentNode === originalParent) return;
      originalParent.insertBefore(menu, originalNextSibling);
    }

    function moveMenuForMobile(trigger) {
      var target = trigger.closest(".mobile-nav__item, .mobile-nav__has-sublist, li") || trigger;
      if (target.contains(menu)) return;
      target.appendChild(menu);
    }

    function setTop(trigger) {
      var rect = trigger.getBoundingClientRect();
      menu.style.setProperty("--smm-top", Math.round(rect.bottom) + "px");
    }

    function openMenu(trigger, event) {
      if (event && event.type === "click" && !isMobile()) {
        event.preventDefault();
      }
      window.clearTimeout(closeTimer);
      closeOtherMenus(menu);
      if (isMobile()) {
        moveMenuForMobile(trigger);
      } else {
        restoreMenuPosition();
      }
      setTop(trigger);
      menu.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    }

    function closeMenu() {
      menu.classList.remove("is-open");
      triggers.forEach(function (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      });
    }

    function queueClose() {
      closeTimer = window.setTimeout(closeMenu, 140);
    }

    triggers.forEach(function (trigger) {
      trigger.setAttribute("aria-haspopup", "true");
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute("aria-controls", panel.id);
      if (trigger.closest(".site-nav__details")) {
        trigger.closest(".site-nav__details").classList.add("smm-native-dropdown-hidden");
      }

      trigger.addEventListener("mouseenter", function (event) {
        openMenu(trigger, event);
      });
      trigger.addEventListener("focus", function (event) {
        if (!isMobile()) openMenu(trigger, event);
      });
      trigger.addEventListener("click", function (event) {
        if (isMobile()) {
          event.preventDefault();
          moveMenuForMobile(trigger);
          menu.classList.toggle("is-open");
          trigger.setAttribute("aria-expanded", menu.classList.contains("is-open") ? "true" : "false");
          return;
        }
        openMenu(trigger, event);
      });
      trigger.addEventListener("mouseleave", queueClose);
    });

    panel.addEventListener("mouseenter", function () {
      window.clearTimeout(closeTimer);
    });
    panel.addEventListener("mouseleave", queueClose);
    window.addEventListener("resize", function () {
      if (!isMobile()) restoreMenuPosition();
      var activeTrigger = triggers.find(function (trigger) {
        return trigger.getAttribute("aria-expanded") === "true";
      });
      if (activeTrigger) setTop(activeTrigger);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeMenu();
    });
  }

  function setupAll() {
    document.querySelectorAll(".smm[data-trigger-label], .smm[data-trigger-url]").forEach(setupMenu);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupAll);
  } else {
    setupAll();
  }
})();
